import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import lazyPlugin from 'vue3-lazy'
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import { VueCookieNext } from 'vue-cookie-next'
import i18n, { localized } from './i18n'
// window.$ = window.jQuery = require('jquery');

const loadimage = require('./assets/images/Loading.gif')

const app = createApp(App)
app.config.globalProperties.$lf = localized

app.use(router)
    .use(lazyPlugin, {
        preLoad: 1.3,
        loading: loadimage,
        attempt: 1
    })
    .use(Toast)
    .use(VueCookieNext)
    .use(i18n)
    .mount('#app')
